const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");
module.exports = function getMediaDownloadPath(media) {
	let external = false;
	let url;
	if (
		media.attributes &&
		!!media.attributes.field_external_url &&
		media.attributes.field_external_url.uri
	) {
		url = media.attributes.field_external_url.uri;
		external = true;
	} else if (generalSettings.data.siteMetaData.directMediaDownload) {
		url =
			media.attributes && media.attributes.drupal_internal__mid
				? `${generalSettings.data.siteMetaData.drupalUrl}/media/${media.attributes.drupal_internal__mid}`
				: `/download?media=${media.id}`;
		external = true;
	} else {
		url = `/download?media=${media.id}`;
	}
	return { uri: url, external };
};
